// §21: two hostnames, split by audience. One build serves both, and which
// surface it is comes from the address bar rather than from the path — so on
// the apex a venue may be called `team` without swallowing the staff screen.
export type Surface = 'staff' | 'public';

// Read per call, not once: a test stubs it, and a build bakes it in.
export function appHost(): string {
  return ((import.meta.env.VITE_APP_HOST as string | undefined) ?? '').trim().toLowerCase();
}

// Where one origin serves both (dev, and a tunnel), the paths are reserved as
// they are on the staff host — otherwise /login would read as a venue's slug.
export const STAFF_PATHS = [
  '/',
  '/team',
  '/settings',
  '/layout',
  '/activity',
  '/platform',
  '/login',
  '/join',
];

export function isStaffPath(pathname: string): boolean {
  return STAFF_PATHS.includes(`/${pathname.split('/')[1] ?? ''}`);
}

export function surfaceFor(hostname: string, pathname: string): Surface {
  const app = appHost();
  if (app === '') return isStaffPath(pathname) ? 'staff' : 'public';
  return hostname.toLowerCase() === app ? 'staff' : 'public';
}
